module.exports = __webpack_public_path__ + "static/img/11.cb479e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/11.png
// module id = 9i4y
// module chunks = 0